module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-2-large-92ee921c181f5ea3a5cc6fd7d45fe383.jpg";